<div class="flx-modal" role="dialog" aria-modal="true">
  <div class="flx-modal__header">
    <h2><i class="fa-regular fa-list-check me-2"></i>{{translate?.general.buttons.select2.singular}} {{translate?.setup.modules.procedure.label.singular}}</h2>
    <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left" (click)="modalRef.hide()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  <div class="flx-modal__subheader_transparent">
    <h3>
      {{translate?.setup.modules.procedure.label.plural}} {{translate?.setup.modules.procedure.messages.groupOf}} {{translate?.task.label.plural | lowercase}} {{translate?.general.messages.toLower}} {{translate?.setup.modules.procedure.messages.beDone}} {{translate?.general.messages.aLower}} {{translate?.setup.modules.procedure.messages.specific}} {{translate?.setup.modules.types.fields.job.singular | lowercase}} . {{translate?.general.buttons.select2.singular}} {{translate?.general.messages.aLower}}
      {{translate?.setup.modules.procedure.label.singular | lowercase}} {{translate?.setup.modules.templates.messages.toBeAdded}} {{translate?.general.messages.toLower}} {{translate?.general.messages.thisLower}} {{translate?.setup.modules.types.fields.job.singular | lowercase}} {{translate?.general.messages.orLower}} {{translate?.general.buttons.create.singular | lowercase}} {{translate?.general.messages.aLower}} {{translate?.general.buttons.new.singular | lowercase}} {{translate?.general.messages.one}}.
    </h3>
  </div>

  <div class="flx-modal__body">
    <div class="field-row field-row--auto_colorpick mb-0">
      <p-dropdown
        placeholder="{{translate?.general.buttons.select2.singular}} {{translate?.setup.modules.procedure.label.singular}}"
        [options]="procedureList"
        [(ngModel)]="selectedProcedure"
        filter="true"
        optionLabel="name"
        optionValue="id"
        [showClear]="true"
        [ngClass]="{
          'ng-invalid ng-touched':
            isAddProcedureBtnClicked && !selectedProcedure
        }"
      ></p-dropdown>
      <button class="btn-list-icon" [pTooltip]="translate?.general.buttons.refresh.singular" (click)="onRefreshClick()" tooltipPosition="left">
        <i class="fa-regular fa-arrows-rotate"></i>
      </button>
    </div>
    <div class="p-error text-10 mt-1" *ngIf="isAddProcedureBtnClicked && !selectedProcedure" >
      <span>{{translate?.setup.modules.procedure.messages.no}} {{translate?.setup.modules.procedure.label.singular | lowercase}} {{translate?.setup.modules.procedure.messages.hasBeenSelected}}. {{translate?.setup.modules.procedure.messages.pleaseSelect}} {{translate?.setup.modules.procedure.label.singular | lowercase}}.</span>
    </div>
  </div>

  <div class="flx-modal__footer-between">
    <p-button
      styleClass="dark"
      [label]="translate?.general.buttons.new.singular + ' ' + translate?.setup.modules.procedure.label.singular"
      icon="fa-regular fa-plus"
      (onClick)="addNewProcedure()"
    ></p-button>
    <div class="triggers">
      <button
        type="button"
        class="custella-btn-white"
        (click)="modalRef.hide()"
      >
        {{ translate?.general.buttons.cancel.singular }}
      </button>
      <p-button
        type="button"
        [label]="translate?.general.buttons.add.singular"
        styleClass="h-32"
        (onClick)="onProcedureAdd()"
      ></p-button>
    </div>
  </div>
</div>
